import { sanitizeEmail, sanitizePhone, sanitizeForEmail } from './sanitize';

const WEB3FORMS_ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY || '';
const SPAM_PROTECTION_DURATION = 15 * 60 * 1000;
const SPAM_PROTECTION_KEY = 'form_spam_protection_siparis';

const checkSpamProtection = (): { allowed: boolean; remainingTime?: number } => {
  try {
    const stored = localStorage.getItem(SPAM_PROTECTION_KEY);

    if (!stored) {
      return { allowed: true };
    }

    const lastSubmissionTime = parseInt(stored, 10);
    const now = Date.now();
    const elapsed = now - lastSubmissionTime;

    if (elapsed >= SPAM_PROTECTION_DURATION) {
      localStorage.removeItem(SPAM_PROTECTION_KEY);
      return { allowed: true };
    }

    const remainingTime = Math.ceil((SPAM_PROTECTION_DURATION - elapsed) / 1000 / 60);
    return { allowed: false, remainingTime };
  } catch {
    return { allowed: true };
  }
};

const setSpamProtection = (): void => {
  try {
    localStorage.setItem(SPAM_PROTECTION_KEY, Date.now().toString());
  } catch {
  }
};

export interface SiparisFormData {
  ad_soyad: string;
  telefon: string;
  email: string;
  mesaj: string;
}

export const sendSiparisEmail = async (formData: SiparisFormData): Promise<void> => {
  if (!WEB3FORMS_ACCESS_KEY) {
    throw new Error('Form gönderim servisi şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin veya bizimle iletişime geçin.');
  }

  const spamCheck = checkSpamProtection();

  if (!spamCheck.allowed) {
    throw new Error(`Form gönderim limiti aşıldı. Güvenlik nedeniyle ${spamCheck.remainingTime} dakika sonra tekrar deneyebilirsiniz.`);
  }

  const sanitizedData = {
    ad_soyad: sanitizeForEmail(formData.ad_soyad),
    telefon: sanitizePhone(formData.telefon),
    email: sanitizeEmail(formData.email),
    mesaj: sanitizeForEmail(formData.mesaj),
  };

  const message = `
Thermomix TM7 - Ürün Satın Alma Talebi

Ad Soyad: ${sanitizedData.ad_soyad}
Telefon: ${sanitizedData.telefon}
E-Posta: ${sanitizedData.email}
Adres: ${sanitizedData.mesaj}
  `.trim();

  const response = await fetch('https://api.web3forms.com/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      access_key: WEB3FORMS_ACCESS_KEY,
      subject: 'Thermomix TM7 - Ürün Satın Alma Talebi',
      from_name: sanitizedData.ad_soyad,
      email: sanitizedData.email,
      message: message,
    }),
  });

  const result = await response.json();

  if (!response.ok || !result.success) {
    const errorMessage = result.message || 'Form gönderilirken bir hata oluştu. Lütfen bilgilerinizi kontrol edip tekrar deneyin.';
    throw new Error(errorMessage);
  }

  setSpamProtection();
};

